"use client";
// import { Box } from "@fastlooptech/layout-components";
import React, { lazy, ReactNode, useEffect, useState } from "react";
import classNames from "classnames";
import { Box } from "@/layouts/LayoutComponents";
import { ImageType } from "@/types/app.type";
import dynamic from "next/dynamic";
// import Video from "@/components/Video/Video";

const Video = dynamic(()=> import("@/components/Video/Video"), {ssr: false});

export interface LandingMobileProps {
  /**
   * The heading of the Landing.
   * @type ReactNode
   * @required
   */
  heading: ReactNode;
  /**
   * The video source used as background of the Landing.
   * @type string
   * @required
   */
  video: string;
  /**
   * The images source the Card.
   * @type ImageType[]
   * @optional
   */
  image?: ImageType;
  /**
   * The video buffering state of the Landing.
   * @type boolean
   * @optional
   */
  isBuffering?: boolean;
  /**
   * The video buffer end event of the Landing.
   * @type () => void
   * @optional
   */
  onBuffer?: () => void;
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;
  /**
  * Mute Video.
   * @type string
   * @required
   */
  muted?: boolean;

  minHeight?: string;

  blurOnLoad?: boolean;
}

export function LandingMobile({minHeight, ...props}: LandingMobileProps) {
  // const [muted, setMuted] = useState(true);
  
  // useEffect(() => {
  //   setTimeout(() => {
  //       setMuted(!!props?.muted);
  //   }, 1000)
  // }, [props?.muted])
  
  // console.log("landing-video", props)
  return (
    <Box
      component="section"
      hAlignContent="center"
      vAlignContent="center"
      column
      className={classNames("relative text-center bg-interactive-landing-video")}
      data-aos={props.animated ? (props.animation || 'fade-in') : ''}
    >
      {/* {props.isBuffering && <LandingSkeleton />} */}
      <Box
        className={classNames(
          // "hidden size-0", 
          { "!block !size-auto": !props.isBuffering, }
        )}
      >
        <Video
          width="100%"
          height="auto"
          className={"rounded-top-banner"}
          minHeight={minHeight || "300px"}
          mobileVideo={props.video}
          controls={true}
          loop
          // playing
          // forcevideo="true"
          // playsinline
          muted={props?.muted}
          onBufferEnd={props.onBuffer}
          pauseable={false}
          autoPlay={true}
          showCustomPlayButton={false}
          posterImage={props?.image?.src}
          poster={props?.image?.src || ""}
          blurOnLoad={props?.blurOnLoad}
        />
      </Box>
      {props.heading}
    </Box>
  );
}
